import config from 'config';
import { handleErrors } from 'api/util';
import { BasicKeyFigureInfo, PageResponse } from 'components/context/types';
import { CompanyTableSortField } from 'components/CommonGroupAndCategoryStuff/CompanyTable';

export async function apiGetUsersGroupsWithCategoryNames(): Promise<Response> {
    return await fetch(`${config.backendUrl}/group/`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(handleErrors);
}

export async function apiCreateGroup(
    groupName: string,
    categoryId?: string
): Promise<Response> {
    return await fetch(`${config.backendUrl}/group/`, {
        method: 'POST',
        body: JSON.stringify({
            groupName,
            categoryId
        }),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(handleErrors);
}

export async function apiDeleteGroup(groupId: string): Promise<Response> {
    return await fetch(`${config.backendUrl}/group/${groupId}`, {
        method: 'DELETE',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(handleErrors);
}

export async function apiGetLatestGroupKeyFigures(
    groupId: string,
    page: number,
    pageSize: number,
    sortField: CompanyTableSortField,
    sortOrder: 'ASC' | 'DESC' | undefined
): Promise<PageResponse<BasicKeyFigureInfo>> {
    return await fetch(
        `${config.backendUrl}/group/${groupId}/keyfigures${'?page=' +
            page}${'&pageSize=' + pageSize}${'&sortField=' +
            sortField}${'&sortOrder=' + sortOrder}`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }
    )
        .then(handleErrors)
        .then(res => res.json())
        .then((data: PageResponse<BasicKeyFigureInfo>) => data);
}

export async function apiGetGroupKeyFigureAggregations(
    groupId: string,
    amount?: number
): Promise<Response> {
    return await fetch(
        `${config.backendUrl}/group/${groupId}/keyfigure-aggregations${
            amount ? '?amount=' + amount : ''
        }`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }
    ).then(handleErrors);
}

export async function apiRemoveCompanyFromGroup(
    groupId: string,
    businessId: string
): Promise<Response> {
    return await fetch(
        `${config.backendUrl}/group/${groupId}/company/${businessId}`,
        {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }
    ).then(handleErrors);
}

export async function apiRemoveAllCompaniesFromGroup(
    groupId: string
): Promise<Response> {
    return await fetch(`${config.backendUrl}/group/${groupId}/company`, {
        method: 'DELETE',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(handleErrors);
}

export async function apiUpdateGroup(
    groupId: string,
    groupName: string
): Promise<Response> {
    return await fetch(`${config.backendUrl}/group/${groupId}`, {
        method: 'PUT',
        body: JSON.stringify({ groupName }),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(handleErrors);
}

export async function apiCheckValidityForAddition(
    businessIds: string[],
    groupId: string
): Promise<Response> {
    return await fetch(`${config.backendUrl}/group/${groupId}/validate`, {
        method: 'POST',
        body: JSON.stringify({
            businessIds
        }),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(handleErrors);
}

export async function apiSaveCompaniesToGroup(
    businessIds: string[],
    groupId: string
): Promise<Response> {
    return await fetch(`${config.backendUrl}/group/${groupId}/company`, {
        method: 'POST',
        body: JSON.stringify({
            businessIds
        }),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(handleErrors);
}
